import { odataFetch } from "@/lib/odata-fetch";
import { QAPPMain_GF_GetBomItems2 } from "@/odata/appu4dm/QAppU4DM";
import { useWorkOrder } from "../work-order/use-work-order";
import { useQuery } from "@tanstack/react-query";
import { bomKeys } from "./bom-keys";
import { APPMain_GF_GetBomItemsResponse } from "@/odata/appu4dm/AppU4DMModel";

export function useBom() {
  const { workOrder } = useWorkOrder();
  const { data, ...query } = useQuery({
    queryKey: bomKeys.get(workOrder?.NId!),
    queryFn: ({ meta }) => fetchBom(workOrder?.NId!, meta!.token!),
    enabled: ({ meta }) => !!(workOrder?.NId && meta?.token),
  });

  return {
    ...query,
    items: data?.value ?? [],
  } as const;
}

export type GetBomItemsResponse = APPMain_GF_GetBomItemsResponse;

async function fetchBom(workerOrderId: string, token: string) {
  const path = new QAPPMain_GF_GetBomItems2().buildUrl({
    function: {
      WorkOrderNId: workerOrderId,
    },
  });
  return odataFetch<APPMain_GF_GetBomItemsResponse>({ path, token });
}
